
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinnagpur() {



const cardData = {
  keyword: 'Cab Service in Nagpur MIDC',
  heading: 'eTravo: Comprehensive and Dependable Corporate Cab Services in Nagpur MIDC',
  headingDescription: 'eTravo provides seamless and efficient corporate cab services in Nagpur MIDC, a prominent industrial hub in Central India. Our solutions are designed for daily employee transport, executive travel, business visits, and operational logistics across the city’s key industrial corridors. Whether your business operates in Hingna, Butibori, or MIHAN SEZ, our GPS-enabled fleet ensures punctuality, safety, and comfort. With flexible booking models, real-time tracking, and courteous drivers, eTravo simplifies workforce movement for factories, IT parks, and service-based firms in and around Nagpur MIDC.',

  top: 'Key Industrial Areas in Nagpur MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Butibori Industrial Area',
      description: 'One of the largest industrial zones in Maharashtra, housing major players like Mahindra, Lupin, and Haldiram’s. eTravo provides reliable shift-based cab services, multi-point employee pickups, and premium travel options for executives and visiting professionals.'
    },
    {
      title: 'MIHAN SEZ (Multi-modal International Hub Airport at Nagpur)',
      description: 'A growing logistics and IT hotspot. Our services include daily staff commutes, airport transfers for clients, and premium vehicles for corporate leaders traveling to or from MIHAN offices.'
    },
    {
      title: 'Hingna MIDC',
      description: 'A well-established manufacturing zone for SMEs and engineering firms. We support daily employee transport with safe, punctual cabs and offer monthly rental plans tailored to small and medium industries.'
    },
    {
      title: 'Kalmeshwar Industrial Area',
      description: 'Located on the outskirts of Nagpur, this area benefits from our cost-effective transport solutions. Our services help businesses reduce absenteeism and ensure timely shift rollouts with GPS-monitored fleets.'
    },
    {
      title: 'Nagpur IT Park',
      description: 'Home to several tech startups and outsourcing companies. eTravo serves this area with on-demand executive cabs, office commute vehicles, and flexible transport packages for night shifts and business meetings.'
    }
  ],

  services: [
    {
      name: 'Nagpur MIDC Corporate Cab Rentals',
      description: 'We offer flexible corporate cab rental plans across Nagpur MIDC including Butibori, Hingna, and MIHAN. Choose from daily, weekly, or monthly rentals based on your business’s transport needs. All rentals come with professional drivers, clean vehicles, and customizable routes. Ideal for staff travel, vendor coordination, or inter-plant logistics. Streamline employee movement while keeping costs predictable.'
    },
    {
      name: 'Employee Transport Cab Nagpur MIDC',
      description: 'Our dedicated employee transport services cater to shift-based factories, BPOs, and manufacturing plants. With fixed routes, safe pickups, and real-time tracking, HR teams can manage workforce logistics more effectively. We cover major employee zones in and around Nagpur. Staff enjoy timely commutes, reducing stress and improving punctuality. Ride notifications and fleet reports available daily.'
    },
    {
      name: 'Business Cab Services Nagpur MIDC',
      description: 'This service is designed for business executives, operations teams, and logistics staff who need on-demand travel across the MIDC belt. Whether it’s for a supplier meeting, audit visit, or inter-factory transfer, eTravo ensures prompt and professional rides. Cabs are available 24/7 and can be booked instantly via our app or hotline. Fuel-efficient routing helps optimize time and cost.'
    },
    {
      name: 'Corporate Staff Cabs Nagpur MIDC',
      description: 'Tailored for workforce mobility, our corporate staff cab service includes dedicated routes for different shifts and departments. Drivers are trained to follow strict pickup/drop-off protocols, and vehicle hygiene is regularly maintained. Large-scale companies in Nagpur rely on us for reliable group transport. Suitable for textile, FMCG, pharma, and logistics industries.'
    },
    {
      name: 'Reliable Corporate Cab Service Nagpur MIDC',
      description: 'Known for punctuality and safety, our reliable service ensures that your teams reach their destinations on time every day. Vehicles are inspected regularly, and replacements are provided immediately in case of delays. We provide dashboards with trip logs and vehicle status to operations teams. Trusted by top industries in Butibori and Hingna for mission-critical commutes.'
    },
    {
      name: 'AC Corporate Cabs Nagpur MIDC',
      description: 'Beat the Nagpur heat with our fully air-conditioned, comfortable, and clean cabs. Each vehicle is equipped with reclining seats, air filters, and proper ventilation systems to ensure a pleasant journey. AC cabs are ideal for long-distance industrial travel, business meetings, and transporting guests. We offer both regular and luxury variants depending on your need.'
    },
    {
      name: 'Staff Pickup and Drop Cab Nagpur MIDC',
      description: 'We specialize in managing large-scale pickup and drop services for multi-shift operations. From early morning shifts to late-night dispatches, we coordinate cab timings with your workforce schedules. Route optimization reduces travel time and fuel cost. Vehicles are tracked live and can accommodate small teams or large factory staff groups. We also manage surge transport needs during audits and inspections.'
    },
    {
      name: 'Affordable Business Cab Rentals Nagpur MIDC',
      description: 'For SMEs and startups, our affordable rentals help manage daily operations without high transport costs. Plans are customizable with transparent billing and no hidden charges. You can rent vehicles for team travel, courier runs, or vendor follow-ups. Discounts are available for monthly commitments. A great fit for logistics coordinators and small unit managers in Nagpur MIDC.'
    },
    {
      name: 'Executive Cab Services Nagpur MIDC',
      description: 'Elevate your executive travel experience with our premium car services. Vehicles include high-end sedans and SUVs with uniformed chauffeurs, bottled water, and WiFi on request. Ideal for CXOs, plant heads, and visiting clients. Available for airport transfers, conferences, and factory tours. Every trip reflects your company’s professionalism.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Nagpur MIDC',
      description: 'Our monthly cab plans are built for large teams needing consistent transport. Packages include daily logs, route tracking, and driver compliance reports. Vehicles are dedicated to your company for the entire contract duration. Enjoy cost predictability, driver continuity, and minimal admin overhead. Best for factories and large service units with high headcounts.'
    },
    {
      name: 'Industrial Area Employee Transport Nagpur MIDC',
      description: 'This service supports the daily movement of skilled and unskilled labor across Nagpur’s industrial belts. Routes are mapped according to workforce location clusters, ensuring faster transit and reduced wait times. Cabs include security features like panic buttons and in-app tracking. Suitable for textile mills, auto ancillaries, and packaging units.'
    },
    {
      name: 'Corporate Client Cabs Nagpur MIDC',
      description: 'Host your clients with comfort and class through our specialized cab services. We offer airport pickups, hotel-to-factory travel, and sightseeing packages for business visitors. Our chauffeurs are well-versed in etiquette and local languages. Impress investors and international partners with timely, hassle-free rides. Executive-class vehicles are always available on demand.'
    },
    {
      name: 'Business Meeting Cabs Nagpur MIDC',
      description: 'When it comes to attending meetings or factory walk-throughs, our cab service ensures you reach the venue prepared and on time. Cabs can be booked for short trips or day-long engagements. Drivers know the best routes to all major industrial zones, helping you avoid traffic and delays. Ideal for sales, audits, and procurement meetings.'
    },
    {
      name: 'Nagpur Industrial Area Cab Hire',
      description: 'Need a vehicle for temporary use? Our cab hire services allow businesses to book cabs without long-term contracts. Ideal for project teams, plant consultants, or event logistics. Choose from hatchbacks to tempo travellers based on your needs. Vehicles are available at short notice and come with round-the-clock support.'
    },
    {
      name: 'Corporate Shuttle Cabs Nagpur MIDC',
      description: 'Our shuttle services connect major residential areas like Wardha Road, Manish Nagar, and Nandanvan to the Nagpur MIDC clusters. Ideal for large firms looking to reduce transport costs while enhancing employee convenience. Fixed time slots, dedicated vehicles, and centralized monitoring make it a popular choice for bulk transport.'
    }
  ],

  tableData: [
    ['Nagpur MIDC Corporate Cab Rentals', 'Employee Transport Cab Nagpur MIDC'],
    ['Business Cab Services Nagpur MIDC', 'Corporate Staff Cabs Nagpur MIDC'],
    ['Reliable Corporate Cab Service Nagpur MIDC', 'AC Corporate Cabs Nagpur MIDC'],
    ['Staff Pickup and Drop Cab Nagpur MIDC', 'Affordable Business Cab Rentals Nagpur MIDC'],
    ['Executive Cab Services Nagpur MIDC', 'Monthly Corporate Cab Rentals Nagpur MIDC'],
    ['Industrial Area Employee Transport Nagpur MIDC', 'Corporate Client Cabs Nagpur MIDC'],
    ['Business Meeting Cabs Nagpur MIDC', 'Nagpur Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Nagpur MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Specialized Cab Services for Nagpur MIDC",
    "WhyChoosedescription": "eTravo provides customized corporate cab solutions for businesses operating in Nagpur MIDC, one of the fastest-developing industrial regions in Central India. Our services are engineered to meet the unique transportation demands of companies in zones like Butibori, Hingna, and Kalmeshwar MIDC. With a strong focus on punctuality, comfort, and safety, we ensure seamless employee commutes and executive travel that contribute to operational efficiency and employee well-being."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Corporate Mobility",
    "WhyChoosedescription": "Our diverse fleet includes sedans, hatchbacks, SUVs, and MUVs, giving companies the flexibility to choose vehicles according to their specific requirements—be it shift-based transportation, business visits, or inter-factory movement. All vehicles are regularly maintained to ensure comfort and reliability."
  },
  {
    "WhyChooseheading": "Professional Drivers Familiar with Nagpur MIDC Routes",
    "WhyChoosedescription": "Our drivers possess deep knowledge of Nagpur’s industrial belts, including Butibori and Hingna MIDC. Their expertise ensures optimized routes, timely service, and minimal disruptions—essential for maintaining schedules in time-sensitive industries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Shift-Based Operations",
    "WhyChoosedescription": "We offer multiple booking models including on-demand rides, scheduled pickups, and long-term contracts. This flexibility is ideal for companies with dynamic shift patterns or expanding workforce needs, allowing transportation to scale with your business."
  },
  {
    "WhyChooseheading": "GPS Tracking and Live Ride Monitoring",
    "WhyChoosedescription": "All vehicles are GPS-enabled, allowing corporate clients to monitor trips in real time. This improves safety, enhances transparency, and provides HR and admin teams with better control over employee commute management."
  },
  {
    "WhyChooseheading": "Clear and Transparent Billing Process",
    "WhyChoosedescription": "We provide monthly invoicing with detailed trip summaries, fare breakdowns, and usage logs. This streamlined billing process simplifies financial reconciliation and ensures complete transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Robust Safety and Hygiene Protocols",
    "WhyChoosedescription": "Each cab undergoes regular sanitization, and our drivers follow stringent safety and hygiene protocols, including mask usage and health checks. These measures ensure a clean, secure, and worry-free travel experience for employees and executives alike."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Corporates",
    "WhyChoosedescription": "Every corporate client is assigned a dedicated account manager to provide end-to-end support—from initial onboarding and route planning to ongoing coordination and issue resolution, ensuring smooth and responsive service."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas are covered in your Nagpur MIDC cab service?",
      answer: "We cover major MIDC zones in Nagpur including Butibori, Hingna, Kalmeshwar, and nearby industrial clusters, offering end-to-end transportation solutions."
    },
    {
      question: "Can we schedule shift-based or recurring employee rides?",
      answer: "Yes, we support recurring ride schedules for shift-based operations and industrial units, ensuring consistent and timely employee transportation."
    },
    {
      question: "Do you offer detailed monthly billing for businesses?",
      answer: "Absolutely. We provide GST-compliant invoices with complete trip logs and fare details, simplifying corporate accounting and reimbursements."
    },
    {
      question: "Are your drivers trained in corporate standards?",
      answer: "Yes, our drivers undergo regular training in safety, professional conduct, and customer service to maintain high corporate standards."
    },
    {
      question: "What safety features are included during rides?",
      answer: "We implement real-time GPS tracking, vehicle sanitization, driver background verification, and health checks to ensure maximum safety."
    },
    {
      question: "Is there a dedicated support contact for corporate clients?",
      answer: "Yes, each corporate client is supported by a dedicated account manager for personalized service and prompt issue resolution."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sandeep Wagh",
    designation: "Operations Head, OrangeTech Manufacturing",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has helped streamline our employee transport in Butibori MIDC. Timely service and flexible options have made a big difference in our shift operations.”"
  },
  {
    name: "Ms. Pooja Deshmukh",
    designation: "HR Executive, Nagpur Pharma Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“Reliable, safe, and professionally managed—eTravo is our go-to corporate cab partner in Nagpur MIDC.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Nagpur MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-nagpur-midc.jpg",
  "description": "Reliable and affordable corporate cab service in Nagpur MIDC for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with professional drivers at eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.82",
    "ratingCount": "6942"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-nagpur-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Nagpur MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Nagpur MIDC for corporate staff transport, business meetings, and industrial commutes. Reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinnagpur;